import { store } from 'redux/store';
import { isAuthenticated } from 'utils/auth';
import { apiInterceptor } from 'utils/apiInterceptor';
/**
 * gets livestream settings
 */
export async function getRecordings(projectId) {
    const user = store?.getState()?.user

    if (isAuthenticated() && user) {
        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API_V2}/manager/livestream/recordings/${projectId}`,
            {
                method: 'GET',
                headers: {
                },
            }
        );

        return await response.json();
    }
}
